import {
  FETCH_CLASS_PERIODS_REQUEST,
  FETCH_CLASS_PERIODS_SUCCESS
} from '../actions/classperiods'

const initialState = {
  items: []
}

export function classperiods (state = initialState, action) {
  switch (action.type) {
    case FETCH_CLASS_PERIODS_REQUEST:
      return Object.assign({}, state, {
        items: []
      })

    case FETCH_CLASS_PERIODS_SUCCESS:
      return Object.assign({}, state, {
        items: action.payload.classPeriods
      })

    default:
      return state
  }
}

